export default __webpack_public_path__ + "1d11bbcb20e5e1e0187bdff306b12bb0.png";